import { Button } from '@/components/Button';
import { F } from '@/design/fonts';
import { SPACE, T } from '@/design/tokens';
import { env } from '@/lib/env';
import { Warehouse } from 'lucide-react';
import { Link } from 'react-router-dom';

export function GarageEmptyState() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: `${SPACE['2xl']}px 0`,
        gap: SPACE.md,
      }}
    >
      <Warehouse size={32} color={T.textMuted} aria-hidden="true" strokeWidth={1.5} />
      <div>
        <h2
          style={{
            margin: 0,
            fontFamily: F.display,
            fontSize: 24,
            color: T.text,
            fontWeight: 600,
          }}
        >
          Your garage is empty
        </h2>
        <p
          style={{
            margin: `${SPACE.sm}px 0 0`,
            color: T.textMuted,
            fontSize: 15,
            lineHeight: 1.6,
            maxWidth: 380,
          }}
        >
          {env.VITE_TRANSFER_ENABLED
            ? 'Add your first vehicle to start building its history, or enter a transfer code if someone is passing a car to you.'
            : 'Add your first vehicle to start building its history.'}
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: SPACE.sm,
          width: '100%',
          maxWidth: 320,
        }}
      >
        {/* Link wraps Button to get React Router client-side navigation. */}
        <Link
          to="/vehicles/new"
          style={{ width: '100%', textDecoration: 'none' }}
          aria-label="Add a vehicle"
        >
          <Button fullWidth tabIndex={-1}>
            Add a vehicle
          </Button>
        </Link>
        {/* G13: mirror the Garage header's VITE_TRANSFER_ENABLED gate so the empty
            state doesn't offer a transfer entry when the feature is disabled. */}
        {env.VITE_TRANSFER_ENABLED ? (
          <Link
            to="/transfer/accept"
            style={{ width: '100%', textDecoration: 'none' }}
            aria-label="Enter a transfer code"
          >
            <Button variant="secondary" fullWidth tabIndex={-1}>
              Enter a transfer code
            </Button>
          </Link>
        ) : null}
      </div>
    </div>
  );
}
